<template>
  <div>
    <div v-if="form" class="has-text-right" dir="rtl">
      <div class="columns">
        <div class="column is-6">
          <p class="bold">Education Institutions</p>
          <NetworkSearchBox
            v-model="form.data.education.fields.education_institution_id.value"
            network-request-name="getAllEducationInstitutions"
            network-post-name="postEducationInstitution"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column is-6">
          <p class="bold">Education Courses</p>
          <NetworkSearchBox
            v-model="form.data.education.fields.education_course_id.value"
            network-request-name="getAllEducationCourses"
            network-post-name="postEducationCourse"
          />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p class="bold">Education Degrees</p>
          <NetworkSearchBox
            v-model="form.data.education.fields.education_degree_id.value"
            network-request-name="getAllEducationDegrees"
            network-post-name="postEducationDegree"
          />
        </div>
        <div class="column">
          <p class="bold">Grade</p>
          <input v-model="form.data.education.fields.grade.value" class="outlined" placeholder="Grade" />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <checkbox
            v-model="form.data.education.fields.with_honors.value"
            :checked="form.data.education.fields.with_honors.value"
            >With Honors</checkbox
          >
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p class="bold">Year Start</p>
          <input v-model="form.data.education.fields.year_start.value" class="outlined" placeholder="Year Start" />
        </div>
        <div class="column">
          <p class="bold">Month Start</p>
          <input v-model="form.data.education.fields.month_start.value" class="outlined" placeholder="Month Start" />
        </div>
      </div>
      <div class="columns mb-3">
        <div class="column">
          <p class="bold">Year End</p>
          <input v-model="form.data.education.fields.year_end.value" class="outlined" placeholder="Year End" />
        </div>
        <div class="column">
          <p class="bold">Month End</p>
          <input v-model="form.data.education.fields.month_end.value" class="outlined" placeholder="Month End" />
        </div>
      </div>
    </div>
    <div class="modal_footer">
      <a @click="submit()" :class="{ 'is-loading': is_loading, faded: is_submitted }" class="button is-info"
        >Submit and Close</a
      >
      <div>
        <a
          @click="submit(true)"
          :class="{ 'is-loading': is_loading, faded: is_submitted }"
          class="button is-warning ml-4"
          >Submit and Create Another One</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Checkbox from '@/components/Checkbox'
import NetworkSearchBox from '@/components/NetworkSearchBox'
export default {
  props: ['payload'],
  name: 'educations-form',
  components: {
    Checkbox,
    NetworkSearchBox
  },
  data () {
    return {
      is_loading: false,
      is_submitted: false,
      form: undefined
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      if (this.payload.is_create) {
        this.setForm({
          id: '',
          education_institution: {},
          education_course: {},
          education_degree: {}
        })
        return
      }
      this.$network_utils
        .getApplicantEducation({
          applicant_education_id: this.payload.data.id,
          current_applicant_id: this.payload.applicant_id
        })
        .then(response => {
          this.setForm(response)
        })
    },
    setForm (form_data) {
      this.form = new this.$form({
        education: {
          fields: {
            education_institution_id: {
              value: form_data.education_institution.id,
              has_error: false,
              validations: []
            },
            education_course_id: {
              value: form_data.education_course.id,
              has_error: false,
              validations: []
            },
            education_degree_id: {
              value: form_data.education_degree.id,
              has_error: false,
              validations: []
            },
            grade: {
              value: form_data.grade,
              has_error: false,
              validations: []
            },
            with_honors: {
              value: form_data.with_honors,
              has_error: false,
              validations: []
            },
            year_start: {
              value: form_data.year_start,
              has_error: false,
              validations: []
            },
            month_start: {
              value: form_data.month_start,
              has_error: false,
              validations: []
            },
            year_end: {
              value: form_data.year_end,
              has_error: false,
              validations: []
            },
            month_end: {
              value: form_data.month_end,
              has_error: false,
              validations: []
            },
            current_applicant_id: {
              value: this.payload.applicant_id,
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: this.payload.is_create ? 'post' : 'put',
            url: '/applicants/educations/' + form_data.id,
            headers: 'applicant_headers'
          },
          is_used: true
        }
      })
    },
    submit (create_another = false) {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then(() => {
        this.is_loading = false
        this.is_submitted = true
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
        if (create_another) {
          this.create({
            designator: 'applicant-educations-form-modal',
            component_name: 'ApplicantEducationsForm',
            is_create: true,
            applicant_id: this.payload.applicant_id,
            modal_title: 'Create new Education'
          })
        }
      })
    },
    ...mapMutations('modals', ['remove', 'create'])
  }
}
</script>
